export default function About() {
  return (
    <div>
      <section className="relative h-[60vh] min-h-[420px]">
        <img src="https://customer-assets.emergentagent.com/job_riddhi-elegance/artifacts/plu0xf2w_e5bfd352-95ac-48c4-89a3-c3921ec65bac.jpg" alt="" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#FDFBF7]/80 to-[#FDFBF7]/10" />
        <div className="absolute inset-0 flex items-center px-6 md:px-12 lg:px-24">
          <div className="max-w-xl fade-up">
            <div className="text-[11px] tracking-overline uppercase text-[#D4AF37] mb-4">Our Story</div>
            <h1 className="font-serif-h font-light text-5xl md:text-6xl text-stone-900 leading-tight">
              A boutique<br /><em className="italic text-[#B3932F]">for keepsake drapes.</em>
            </h1>
          </div>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-24 py-24 grid grid-cols-1 lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <div className="text-[11px] tracking-overline uppercase text-stone-500 mb-3">Est. 2024</div>
          <h2 className="font-serif-h font-light text-4xl text-stone-900 leading-tight">
            We began with a single drape, and a quiet promise.
          </h2>
        </div>
        <div className="lg:col-span-7 space-y-6 text-stone-700 font-light leading-relaxed">
          <p>
            <span className="font-serif-h text-5xl text-[#D4AF37] float-left mr-3 leading-none">R</span>
            iddhi was born from a simple conviction — that a woman's wardrobe deserves pieces she returns to, remembers,
            and passes on. In a world of fast cycles, we are unhurried. We work with handloom weavers in Benares,
            block-printers in Jaipur, and master embroiderers in Lucknow.
          </p>
          <p>
            Every saree is woven on a pitloom. Every lehenga is embroidered by a single pair of hands across weeks.
            Every kurti is stitched in ateliers where craft still feels like conversation.
          </p>
          <p>
            The result — drapes that look heirloom from the very first wear and feel softer with every season that follows.
          </p>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-24 py-20 bg-[#F8EDE9]">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-center">
          {[
            { n: "120+", l: "Artisan Partners" },
            { n: "14", l: "Handloom Clusters" },
            { n: "9,200+", l: "Women Who Wear Riddhi" },
          ].map((s) => (
            <div key={s.l}>
              <div className="font-serif-h text-5xl md:text-6xl text-[#B3932F]">{s.n}</div>
              <div className="text-[11px] tracking-overline uppercase text-stone-600 mt-3">{s.l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* FOUNDERS */}
      <section className="px-6 md:px-12 lg:px-24 py-24 grid grid-cols-1 lg:grid-cols-12 gap-14 items-center" data-testid="founders-section">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="text-[11px] tracking-overline uppercase text-[#5A1618] mb-3">The Promoters</div>
          <h2 className="font-serif-h font-light text-4xl md:text-5xl text-stone-900 leading-tight">
            Meena Raghu &<br/>Naveen Raghu
          </h2>
          <div className="mt-3 text-[11px] tracking-overline uppercase text-[#D4AF37]">Siblings · Founders of Riddhi</div>
          <p className="mt-6 text-stone-700 font-light leading-relaxed">
            Riddhi is the shared dream of two siblings — Meena Raghu, a curator with an instinct for handloom, and
            Naveen Raghu, who built the boutique from a single weave to the atelier you see today. Together they hand-pick
            every saree, kurti, and lehenga from weavers and artisans across South India, with a quiet promise: nothing
            leaves Riddhi unless they would wear it themselves.
          </p>
          <div className="mt-8 grid grid-cols-2 gap-6 max-w-md">
            <div>
              <div className="text-[11px] tracking-overline uppercase text-stone-500">Meena Raghu</div>
              <div className="text-stone-800 font-medium mt-1">Curator & Co-founder</div>
            </div>
            <div>
              <div className="text-[11px] tracking-overline uppercase text-stone-500">Naveen Raghu</div>
              <div className="text-stone-800 font-medium mt-1">Co-founder</div>
            </div>
          </div>
        </div>
        <div className="lg:col-span-7 order-1 lg:order-2 relative">
          <div className="relative h-[560px] md:h-[640px] overflow-hidden rounded-sm bg-[#F8EDE9]">
            <img src="https://customer-assets.emergentagent.com/job_riddhi-elegance/artifacts/36r46ypx_PHOTO-2026-04-25-01-24-01.jpg"
                 alt="Meena Raghu & Naveen Raghu — Siblings, Founders of Riddhi"
                 className="w-full h-full object-cover object-center" />
            {/* Gold hairline accent */}
            <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent opacity-70" />
          </div>
          <div className="absolute -bottom-5 -left-5 bg-[#FDFBF7] border border-warm px-5 py-3 hidden md:block shadow-sm">
            <div className="text-[10px] tracking-overline uppercase text-stone-500">Bengaluru</div>
            <div className="font-serif-h text-lg">Mahalaxmi Layout Atelier</div>
          </div>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-24 py-24 grid grid-cols-1 md:grid-cols-2 gap-10">
        {[
          { t: "Slow Craft", d: "We work with fewer weavers, for longer, and pay fair wages above industry standard." },
          { t: "Natural Fibers", d: "Pure silks, chanderi, organza, linen — fibers that breathe and age beautifully." },
          { t: "Limited Editions", d: "Most pieces are made in runs of 8–20, often never re-stocked once sold." },
          { t: "Mindful Packaging", d: "Recycled kraft boxes, cloth pouches, no plastic — ever." },
        ].map((v) => (
          <div key={v.t} className="border-t border-warm pt-8">
            <div className="text-[11px] tracking-overline uppercase text-[#D4AF37] mb-3">{v.t}</div>
            <p className="text-stone-700 font-light text-lg leading-relaxed">{v.d}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
